import React, { useEffect, useState } from "react";
import PackageUpdateModal from "./PackageUpdateModal";
import { useNavigate } from "react-router-dom";
import { getStoreLocalData } from "../../utils/localStorage";
import PackagePriceUpdateModal from "./PackagePriceUpdateModal";

const PackageInfoCard = ({
  orderPackageData,
  storeCustomerId,
  storeId,
  bookingOrderId,
  sendDataToOrderGarmentInfo,
  userRole,
  orderEditByStore,
  orderEditByRider,
  customerOrdersData,
  offerPriceEnabled
}) => {
  const navigate = useNavigate();
  const [packageUpdateModalVisible, setPackageUpdateModalVisible] =
    useState(false);

  const [packagePriceUpdateModalVisible, setPackagePriceUpdateModalVisible] =
    useState(false);
  const [selectedPackageItemValue, setSelectedPackageItemValue] =
    useState(null);

  const { storeLocalData } = getStoreLocalData();

  const receiveDataFromPackageUpdateModal = ({ success }) => {
    if (success) {
      sendDataToOrderGarmentInfo({
        info: true,
      });
    }
  };

  const [show, setShow] = useState(false);

  const handleShowHide = () => {
    setShow(!show);
  };

  const renderOrderInfoItem = () => {
    return orderPackageData?.map((item, index) => {
      const packageName = item.packageDTO.name;
      return (
        <div className="flex-1 mx-3 my-2 pb-3">
          <div
            className="shadow-3 mt-4 border-1"
            style={{ borderColor: "#1f7a8c" }}
          >
            <div
              className="mx-3"
              style={{
                position: "relative",
                top: -12,
              }}
            >
              <p
                className="text-xl font-medium capitalize px-2"
                style={{ backgroundColor: "#fff", width: "max-content" }}
              >
                {packageName}
              </p>
            </div>
            <div className="flex">
              <div className="flex flex-1 flex-column">
                <div className="mx-3 mt-2">
                  <p className="text-md font-normal capitalize">Service :</p>
                  <p className="text-xl font-medium capitalize">
                    {item.packageDTO.appService}
                  </p>
                </div>
                <div className="mx-3 mt-2 flex flex-row gap-4">
                  
                  {offerPriceEnabled && item.offerPrice !== item.totalPrice && item?.offerPrice !== 0 && <div>
                    <p className="text-md font-normal capitalize">
                      Offer Price :
                    </p>
                    <p className="text-xl font-medium capitalize">
                      {storeLocalData?.currencySymbol} {item.offerPrice}{" / "}{item.packageDTO.quantity} {item.packageDTO.serviceUnit}
                    </p>
                  </div>}
                  <div >
                    <p className="text-md font-normal capitalize">
                      Total Price :
                    </p>
                    <p className="text-xl font-medium capitalize">
                      {storeLocalData?.currencySymbol} {item.totalPrice}
                    </p>
                  </div>
                </div>
                <div className="mx-3 mt-2">
                  <p className="text-md font-normal capitalize">
                    Package Count :
                  </p>
                  <p className="text-xl font-medium capitalize">
                    {item.packageCount}
                  </p>
                </div>
              </div>
              <div className="flex flex-1 flex-column">
                <div className="mx-3 mt-2">
                  <p className="text-md font-normal capitalize">
                    Description :
                  </p>
                  <p className="text-xl font-medium capitalize">
                    {item.packageDTO.quantity} {item.packageDTO.serviceUnit} for
                    {storeLocalData?.currencySymbol} {item.packageDTO.amount}
                  </p>
                </div>
                <div className="mx-3 mt-2">
                  <p className="text-md font-normal capitalize">
                    Total {item.packageDTO.serviceUnit} :
                  </p>
                  <div className="flex flex-row justify-content-between align-items-center">
                    <p className="text-xl font-medium capitalize">
                      {item.itemCount + item.countGram}
                    </p>
                    {userRole === "BY_STORE" && <div
                      onClick={() => {
                        navigate("/PackageTagView", {
                          state: {
                            customerOrdersData: customerOrdersData,
                            orderPackageData: item,
                          },
                        })
                      }}
                    >
                      <img
                        src={"images/rfid-tags.png"}
                        style={{
                          width: 25,
                          height: 25,
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>}

                    {item.packageDTO.serviceUnit === 'Qty' && userRole !== "BY_SUPPORT_ADMIN" && <div
                      onClick={() => {
                        // handleRemoveFromCart(item.itemId);
                        setSelectedPackageItemValue(item);
                        setPackagePriceUpdateModalVisible(true);
                      }}
                    >
                      <i
                        className="pi pi-pencil"
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>}
                    {userRole !== "BY_SUPPORT_ADMIN" &&
                      <div>
                    {(item.carryForward !== true || (item.carryForwardCount + item.countGram) > 0) &&
                      [
                        "BOOKED",
                        "PROCESSED",
                        "INPROCESS",
                        "IN_WAREHOUSE",
                        "UNPROCESSED",
                      ].includes(customerOrdersData.status) &&
                      (item.packageDTO.serviceUnit !== "Qty" &&
                        ((userRole === "BY_STORE" && orderEditByStore) ||
                          (userRole === "BY_RIDER" && orderEditByRider) ||
                          userRole !== "BY_ADMIN" ||
                          userRole !== "BY_SUB_ADMIN_USER") ? (
                        <div
                          onClick={() => {
                            // handleRemoveFromCart(item.itemId);
                            setSelectedPackageItemValue(item);
                            setPackageUpdateModalVisible(true);
                          }}
                        >
                          <i
                            className="pi pi-pencil"
                            style={{
                              fontSize: "25px",
                              cursor: "pointer",
                              color: "#2B70D7",
                            }}
                          ></i>
                        </div>
                      ) : (
                        userRole !== "BY_STORE" &&
                        userRole !== "BY_ADMIN" &&
                        userRole !== "BY_SUB_ADMIN_USER" &&
                        userRole !== "BY_FRANCHISE_ADMIN" && (
                          <div style={{ position: "relative" }}>
                            <div>
                              <i
                                className="pi pi-pencil"
                                style={{
                                  fontSize: "25px",
                                  cursor: "pointer",
                                  color: "#2B70D7",
                                }}
                              ></i>
                            </div>
                            <div style={{ position: "absolute", top: 0 }}>
                              <img
                                src={"Icons/lock.png"}
                                style={{
                                  width: 20,
                                  height: 20,
                                  backgroundColor: "transparent",
                                }}
                              />
                            </div>
                          </div>
                        )
                      ))}
                      </div>
                    }
                  </div>
                </div>
                {item.carryForward === true && (
                  <div className="mx-3 mt-2">
                    <p className="text-md font-normal capitalize">
                      Carry Forward Invoice No. :
                    </p>
                    <p className="text-xl font-medium capitalize">
                      {item.carryForwardInvoiceNo}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  return (
    <div style={{ marginBottom: 10 }}>
      <div
        className="shadow-2 mx-4 mt-2 mb-4 border-2 border-round-lg cursor-pointer"
        style={{ borderColor: "#EF7D58" }}
      >
        <div
          className="px-3 pb-1 flex flex-row justify-content-between align-items-center"
          style={{
            backgroundColor: "#EF7D58",
          }}
          onClick={handleShowHide}
        >
          <p className="text-white text-3xl font-bold capitalize">
            Package Info
          </p>
          <i
            className={!show ? "pi pi-angle-down" : "pi pi-angle-up"}
            style={{
              fontSize: "25px",
              cursor: "pointer",
              color: "#fff",
            }}
          ></i>
        </div>

        {show && renderOrderInfoItem()}
      </div>
      <PackageUpdateModal
        setPackageUpdateModalVisible={setPackageUpdateModalVisible}
        packageUpdateModalVisible={packageUpdateModalVisible}
        sendDataToPackageUpdateModal={receiveDataFromPackageUpdateModal}
        storeId={storeId}
        storeCustomerId={storeCustomerId}
        selectedPackageItemValue={selectedPackageItemValue}
        bookingOrderId={bookingOrderId}
        offerPriceEnabled={offerPriceEnabled}
      />

      <PackagePriceUpdateModal
        setPackagePriceUpdateModalVisible={setPackagePriceUpdateModalVisible}
        packagePriceUpdateModalVisible={packagePriceUpdateModalVisible}
        sendDataToPackageUpdateModal={receiveDataFromPackageUpdateModal}
        storeId={storeId}
        storeCustomerId={storeCustomerId}
        selectedPackageItemValue={selectedPackageItemValue}
        bookingOrderId={bookingOrderId}
      />
    </div>
  );
};

export default PackageInfoCard;
